import * as React from "react";
import Svg, { Path } from "react-native-svg";
function UnSelectedRadioButton(props) {
    return (React.createElement(Svg, { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props },
        React.createElement(Path, { d: "M3.75 17.5a1.2 1.2 0 01-.875-.375 1.2 1.2 0 01-.375-.875V3.75a1.2 1.2 0 01.375-.875A1.2 1.2 0 013.75 2.5h12.5a1.2 1.2 0 01.875.375c.25.25.375.542.375.875v12.5a1.2 1.2 0 01-.375.875 1.2 1.2 0 01-.875.375H3.75zm0-1.25h12.5V3.75H3.75v12.5z", fill: "#667085" })));
}
export default UnSelectedRadioButton;
